module.exports = __webpack_public_path__ + "motor_round-1af8cd8fa151d994b6f447b73ccecc5b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/motor_round.png
// module id = 1185
// module chunks = 1 2